import styled from "styled-components";
export const AreaOfStrength = styled.h4`
  margin-bottom: 16px;
`;
